import styled from 'styled-components';

export const StyledSwitchContainer = styled.div`
    margin-top: 24px;
    display: flex;
    align-items: center;
    gap:10px;
`;